<template>
    <v-layout
        row
        wrap
        class="activity-feed">
        <v-flex xs12>
            <v-flex xs12>
                <v-card class="panelBlock">
                    <v-expansion-panel class="about-section" expand v-model="isPanelOpen">
                        <v-expansion-panel-content>
                            <div slot="header">
                                <h2 class="admin-page__header" data-qe-id = "inappropriate_post_content">{{communityCommonConstant.INAPPROPRIATE_POSTS}}</h2>
                            </div>
                            <v-flex xs12 class="activity-feed__posts">
                                <activity-feed
                                    :show-inappropriate-posts="true"
                                    :is-admin-page-feed="true"
                                    :feed-list="activityFeedList"
                                    :list-loading="loadPostsAction"></activity-feed>
                            </v-flex>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-card>
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
import ActivityFeed from '../../ChapterPage/ActivityFeed/ActivityFeed';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import { storeAction } from '@/store/storeActions.constant';
import { storeGetters } from '@/store/storeGetters.constant';
import { communityCommonConstant } from '../communityCommon.constant';
import { storeMutation } from "@/store/storeMutations.constant";

export default {
  name: 'AdminPage',
  components: {
    ActivityFeed,
  },
  data: () => {
    return {
      communityCommonConstant,
      isPanelOpen: [],
    };
  },
  async created() {
    await this.getAdminFeedList();
    if (this.singleAdminFeedPost) {
      this.hideMainActivityFeed(true);
      this.isPanelOpen = [1];
    } else {
      this.hideMainActivityFeed(false);
    }
  },
  methods: {
    ...mapActions({
      getAdminFeedList: `chapter/${storeAction.getAdminFeedList}`,
    }),
    ...mapMutations({
      hideMainActivityFeed: `chapter/${storeMutation.hideMainActivityFeed}`,
    }),
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      adminFeedList: `chapter/${storeGetters.adminFeedList}`,
    }),
    loadPostsAction() {
      return this.actions[storeAction.getAdminFeedList];
    },
    selectedPostIdFromRoute() {
        return this.$route.query && this.$route.query.postId;
    },
    singleAdminFeedPost() {
      if (this.selectedPostIdFromRoute && this.adminFeedList && this.adminFeedList.length) {
        return this.adminFeedList.find(post => post.id === this.selectedPostIdFromRoute);
      }
      return null;
    },
    activityFeedList() {
      return this.singleAdminFeedPost ? [this.singleAdminFeedPost] : this.adminFeedList;
    },
  },
};
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .activity-feed {
        position: relative;

        &__posts {
            background-color: $ypo-title-blue-gray;
            padding: 10px;
        }
    }

    .no-activity-yet {
        color: $ypo-title-blue-gray;
        background-color: $white;
        font-size: 28px;
        letter-spacing: -0.17px;
        line-height: 38px;
    }

    .admin-page {
        &__header {
            float: right;
        }
    }
</style>
